import project from '../../project.config'
const redirect = project.authRedirect
const logoutUrl = project.authLogoutUrl
const audience = project.authAudience
const domain = project.authDomain
const clientId = project.authClientId
export const config = {
  redirect,
  logoutUrl,
  domain,
  clientId,
  audience
}



// WEBPACK FOOTER //
// ./src/auth/config.js